<template>
  <div class="app">
       fenxianghdong
  </div>
</template>

<script>
export default {
    data () {
      return {
        alertState:false,
        alertData:'',
      }
    },
    created(){
     
    },
    methods:{
      
    },
    components:{
     
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/fenxiang.vue